<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            label="부서"
            name="deptCd"
            v-model="searchParam.deptCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-multi-field
            isArray
            label="점검자"
            name="checkUserIds"
            v-model="searchParam.checkUserIds"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="순회기간"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :editable="editable"
            :comboItems="completeFlagItems"
            itemText="codeName"
            itemValue="code"
            label="진행상태"
            name="patrolStepCd"
            v-model="searchParam.patrolStepCd">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :comboItems="lineItems"
            :editable="editable"
            itemText="lineCd"
            itemValue="lineId"
            label="라인"
            name="lineId"
            v-model="searchParam.lineId">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :comboItems="placeItems"
            :editable="editable"
            itemText="placeName"
            itemValue="placeId"
            label="장소"
            name="placeId"
            v-model="searchParam.placeId">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="card-body qtable-card-body">
      <q-table
        grid
        class="qtable-card"
        title=""
        :data="grid.data"
        :columns="grid.columns"
        hide-header
        hide-bottom
        :rows-per-page-options="[0]"
        virtual-scroll
      >
        <template v-slot:top-right>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <q-card class="mobileTableCardLayer" @click="linkClick(null,props.row)">
              <q-card-section class="grid-card-etc">
                <div :class="['text-grid-etc', getColorStatus(props.row.patrolStepCd)]">
                  {{ props.row.patrolStepName }}
                </div>
              </q-card-section>
              <q-card-section>
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.patrolName }}</div>
              </q-card-section>
              <q-card-section class="grid-card-etc">
                <div class="text-grid-etc">
                  {{ props.row.patrolStartDate }} | {{ props.row.deptName }} | {{ props.row.checkUserName }} 
                </div>
              </q-card-section>
            </q-card>
          </div>
        </template>
      </q-table>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
        <q-card class="mobileTableCardLayer">
          <q-card-section class="text-center">
            <q-card-section class="q-pt-xs">
              <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
            </q-card-section>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "env-patrol",
  props: {
  },
  data() {
    return {
      closeUpdate: '',
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "patrolDate",
            field: "patrolDate",
            label: "순회일",
            style: 'width:180px',
            align: "center",
            sortable: true,
          },
          {
            name: "patrolName",
            field: "patrolName",
            label: "순회점검명",
            style: 'width:200px',
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "deptName",
            field: "deptName",
            style: 'width:100px',
            label: "부서",
            align: "center",
            sortable: true,
          },
          {
            name: "checkUserName",
            field: "checkUserName",
            style: 'width:200px',
            label: "점검자",
            align: "center",
            sortable: true,
          },
          {
            name: "lineCd",
            field: "lineCd",
            style: 'width:100px',
            label: "라인",
            align: "center",
            sortable: true,
          },
          {
            name: "placeName",
            field: "placeName",
            style: 'width:100px',
            label: "장소",
            align: "center",
            sortable: true,
          },
          {
            name: "patrolStepName",
            field: "patrolStepName",
            style: 'width:100px',
            label: "진행상태",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        vendorCd: null,
        patrolStepCd: null,
        period: [],
        checkUserIds: [],
        startYmd: '',
        endYmd: '',
        placeId: null,
        lineId: null,
      },
      period: [],
      editable: true,
      searchUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      completeFlagItems: [
        { code: 'N', codeName: '작성중' },
        { code: 'Y', codeName: '완료' },
      ],
      isResult: false,
      lineItems: [],
      placeItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  watch: {
    'closeUpdate'() {
      console.log('closeUpdate', this.closeUpdate)
    }
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.patrol.list.url;
      // url setting
      this.setData();
      this.getList();
    },
    getColorStatus(cd) {
      var cls = '';
      switch(cd) {
        case 'Y': // 완료
          cls = 'txt-box-grid text-orange-box';
          break;
        default : // 작성중
          cls = 'txt-box-grid text-primary-box';
          break;
      }
      return cls;
    },
    setData() {
      this.$http.url = selectConfig.mdm.line.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.lineItems = _result.data;
      },);
      this.$http.url = selectConfig.mdm.place.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.placeItems = _result.data;
      },);
    },
    getList() {
      if (this.searchParam.period && this.searchParam.period[0]) {
        this.searchParam.startYmd = this.searchParam.period[0];
        this.searchParam.endYmd = this.searchParam.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    openPopup() {
      this.linkClick(null);
    },
    linkClick(evt, row) {
      this.popupOptions.title = "환경 순회점검 상세"; // 환경 순회점검 상세
      this.popupOptions.param = {
        envPatrolId: row ? row.envPatrolId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./envPatrolDetail.vue"}`);
      // this.popupOptions.isFull = true;
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
